@if (showAboutThisPage) {
  <div class="onboarding-page-overlay"></div>
}

<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Assets'"
      [customBack]="'more'"
      [canGoBack]="!windowService.isDesktopRes"
      [showLinkIcon]="true"
      [linkIcon]="'add-circle'"
      (linkAction)="goToAddRoomItemPage()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true" [isPrimaryLayer]="true">
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (windowService?.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-text
            [title]="'Assets'" />
          <form [formGroup]="form" novalidate action="#">
            <tidy-search-input
              formControlName="search"
              [placeholder]="'Search'"
              [icon]="'assets/img/search-header.svg'"
              class="header-search" />
          </form>
          @if (!showAboutThisPage) {
            <tidy-small-button
              [text]="'Add Asset'"
              [image]="'assets/img/add-button-white.svg'"
              (buttonClick)="goToAddRoomItemPage()" />
          }
          @if (!showAboutThisPage) {
            <tidy-image
              [src]="'assets/img/download_csv.svg'"
              class="desktop-header-icon secondary-text-icon"
              (action)="exportCSV()"/>
          }
        </div>
        <div class="non-wrappable-right-aligned-container">
          @if (showLoadingSpinner) {
            <ion-spinner name="lines" class="header-loading-spinner" />
          }
          <automations-preview-button
            [tag]="'assets'" />
        </div>
      </tidy-desktop-header>
    }

@if (!windowService?.isDesktopRes) {
  @if (allRows?.length) {
    <form [formGroup]="form" novalidate action="#">
      <tidy-search-input
        formControlName="search"
        [placeholder]="'Search'"
        [icon]="'assets/img/search-header.svg'"
        class="header-search" />
    </form>
  }
}

<!-- Skeleton table while loading — rows float in with the entrance cascade;
     the real table below then replaces it in place, instantly (skipEntrance). -->
@if (windowService?.isDesktopRes && !loaded) {
  <tidy-table
    [skeletonLoading]="true"
    [columnslabels]="headers" />
}

@if (loaded) {
  <tidy-table
    #tidyTable
    [dataSource]="shownRows"
    [displayedColumns]="headers"
    [columnslabels]="headers"
    (sortChange)="sortChanged($event)"
    [showColumnLines]="false"
    [rowsToShow]="50"
    [allRowIsClickable]="true"
    [skipEntrance]="true"
    (cellClick)="onTableColumnClick($event)"
    [infiniteScroll]="true"
    [totalRows]="totalRows"
    (pageChange)="pageChange($event)"
    [blockSorting]="true" />
}

</tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />


@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'maintenance'" (dismissed)="dismissAboutThisPage()" />
}
